export const MOCK_MATCHES = [
  {
    id: 't1',
    initial: 'س',
    price: 900000,
    nearestKey: 'sat1800',
    nearestDateId: '18',
    nearestTime: '18:30',
    sessionsCount: 85,
    capabilityKeys: ['anxiety', 'sleep', 'work', 'adult'],
    approachKey: 'cbt',
    recommended: true,
  },
  {
    id: 't2',
    initial: 'ن',
    price: 700000,
    nearestKey: 'sun1630',
    nearestDateId: '19',
    nearestTime: '16:30',
    sessionsCount: 110,
    capabilityKeys: ['mood', 'work', 'adult'],
    approachKey: 'integrative',
    recommended: false,
  },
  {
    id: 't3',
    initial: 'ا',
    price: 1200000,
    nearestKey: 'tue1900',
    nearestDateId: '21',
    nearestTime: '20:00',
    sessionsCount: 140,
    capabilityKeys: ['trauma', 'anxiety', 'adult'],
    approachKey: 'psychodynamic',
    recommended: false,
  },
]

export function getMockMatch(id) {
  return MOCK_MATCHES.find((person) => person.id === id) || null
}

/** Sample first-session slots (legacy date chips — kept for checkout labels). */
export const MOCK_BOOKING_DATES = [
  {id: 'd1', fa: 'شنبه ۱۵ شهریور', en: 'Saturday, 15 Shahrivar'},
  {id: 'd2', fa: 'یکشنبه ۱۶ شهریور', en: 'Sunday, 16 Shahrivar'},
  {id: 'd3', fa: 'دوشنبه ۱۷ شهریور', en: 'Monday, 17 Shahrivar'},
  {id: 'd4', fa: 'سه‌شنبه ۱۸ شهریور', en: 'Tuesday, 18 Shahrivar'},
]

export const MOCK_BOOKING_TIMES = ['16:30', '18:00', '19:30', '21:00']

export function getMockBookingDate(id) {
  return MOCK_BOOKING_DATES.find((item) => item.id === id) || null
}

export const MOCK_BOOKING_CODE = 'RB-48219'

export const MOCK_RECEIPT_CODE = 'RCP-90331'

export const MOCK_RECEIPT_MISMATCH = 'RCP-90344'

export const MOCK_MISMATCH_AMOUNT = 450000

export const CONSENT_VERSION = '1.0.2'

export const HOLD_SECONDS = 15 * 60

/** BOOK-01 mock calendar (Mordad 1404 style). */
export const MOCK_CAL_MONTH = {
  id: 'mordad-1404',
  fa: 'مرداد ۱۴۰۴',
  en: 'Mordad 1404',
  leadingMuted: [28, 29, 30],
  daysInMonth: 31,
  availableDays: [6, 11, 14, 18, 19, 21, 25, 28],
  dayMeta: {
    6: {fa: '۶ مرداد · سه‌شنبه', en: '6 Mordad · Tuesday'},
    11: {fa: '۱۱ مرداد · یکشنبه', en: '11 Mordad · Sunday'},
    14: {fa: '۱۴ مرداد · سه‌شنبه', en: '14 Mordad · Tuesday'},
    18: {fa: '۱۸ مرداد · دوشنبه', en: '18 Mordad · Monday'},
    19: {fa: '۱۹ مرداد · سه‌شنبه', en: '19 Mordad · Tuesday'},
    21: {fa: '۲۱ مرداد · پنجشنبه', en: '21 Mordad · Thursday'},
    25: {fa: '۲۵ مرداد · یکشنبه', en: '25 Mordad · Sunday'},
    28: {fa: '۲۸ مرداد · سه‌شنبه', en: '28 Mordad · Tuesday'},
  },
}

export const MOCK_CAL_SLOTS = [
  {time: '09:00', period: 'morning'},
  {time: '10:00', period: 'morning'},
  {time: '11:30', period: 'morning'},
  {time: '14:00', period: 'day'},
  {time: '16:30', period: 'day'},
  {time: '18:30', period: 'day'},
  {time: '20:00', period: 'night'},
  {time: '21:00', period: 'night'},
]

export const MOCK_RESCHEDULE_SLOTS = [
  {id: 'alt1', fa: 'سه‌شنبه ۱۰:۰۰', en: 'Tuesday 10:00'},
  {id: 'alt2', fa: 'پنجشنبه ۱۶:۰۰', en: 'Thursday 16:00'},
  {id: 'alt3', fa: 'شنبه ۱۹:۳۰', en: 'Saturday 19:30'},
]

export function getBookingDayLabel(dayId, locale) {
  const meta = MOCK_CAL_MONTH.dayMeta[String(dayId)] || MOCK_CAL_MONTH.dayMeta[Number(dayId)]
  if (!meta) {
    return String(dayId)
  }
  return locale === 'en' ? meta.en : meta.fa
}

export function formatBookingSummary(dayId, time, locale) {
  const day = getBookingDayLabel(dayId, locale)
  if (!time) {
    return day
  }
  const timePart = locale === 'en' ? time : String(time).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d])
  return day + (locale === 'en' ? ' · ' : ' ساعت ') + timePart
}

/** PAY kit summary: day · weekday TIME (no «ساعت»). */
export function formatPaySummary(dayId, time, locale) {
  const day = getBookingDayLabel(dayId, locale)
  if (!time) {
    return day
  }
  const timePart = locale === 'en' ? time : String(time).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d])
  return day + ' ' + timePart
}
